import { type ReactElement } from 'react';

import type { TaskInboxItemViewModel } from '@/features/patient-record/types';

import { TaskInboxRow } from './TaskInboxRow';

/** Opens the edit modal for an editable (person-scoped) task. */
export type OnEditTask = (guid: string, taskId: string) => void;

interface TaskInboxRowItemProps {
  readonly task: TaskInboxItemViewModel;
  readonly entityName: string | null;
  readonly onEdit: OnEditTask;
  /** Forwarded to the row — off in the grouped view (name is in the header). */
  readonly showRecordLink?: boolean;
}

/**
 * A single `<li>` inbox row shared by the list and grouped views. Only
 * person-scoped tasks carry an owning guid the (person-based) edit modal can
 * open; everything else renders read-only, exactly as before.
 */
export function TaskInboxRowItem({
  task,
  entityName,
  onEdit,
  showRecordLink = true,
}: TaskInboxRowItemProps): ReactElement {
  const editGuid = task.entityType === 'person' ? task.entityGuid : null;
  return (
    <li>
      <TaskInboxRow
        task={task}
        entityName={entityName}
        showRecordLink={showRecordLink}
        onSelect={
          editGuid !== null
            ? () => {
                onEdit(editGuid, task.id);
              }
            : undefined
        }
      />
    </li>
  );
}
